import { AnyEventObject } from 'xstate';
import { patchData, postData } from '~/utils/service';
import { Scope } from '../../../step-machine/types';
import { BasicInfoFormValues } from './types';
import { transformBasicInfoFormToApi, transformBasicInfoFormToUpdateApi } from './utils';

const ROUTE_NAME = 'msaasListing';

export const API_CALLS = {
  create: async ({ input }: { input: Scope<BasicInfoFormValues> }) => {
    const event = input.event as AnyEventObject;
    return await postData(ROUTE_NAME, {
      data: event.payload.values,
      transformRequest: transformBasicInfoFormToApi,
    });
  },
  patch: async ({ input }: { input: Scope<BasicInfoFormValues> }) => {
    const event = input.event as AnyEventObject;
    return await patchData(ROUTE_NAME, {
      pathParams: { id: event.payload.values.id?.toString() || '' },
      data: event.payload.values,
      transformRequest: transformBasicInfoFormToUpdateApi,
    });
  },
};
